<template lang="pug">
  .DigitalEducation
    top-informations(title="数字教育" subtitle="AI挖掘潜能，培养未来综合人才" text="AI trains future talent")
    project-design(text="AI能力驱动学校“教、考、管、营销”场景智能变革；通过区块链+PaaS的开放数据服务能力，为企业提供全自动智慧教育服务；深度洞察教育行业，提供个性化解决方案；加快实现教育行业智能化转型，提升教育质量，促进教育公平公正让孩子成为最好的自己。")
    framework(:framework="framework")
    product-servers(text="教育解决方案全景图，AI驱动教育场景变革" :products="products")
    advantage(:advatages="advantages")
    scene(:scenes="['基础教育', '学前教育', '高等教育', '职业教育']")
</template>

<script>
  import TopInformations from "@/views/Solution/components/TopInformations/TopInformations";
  import ProjectDesign from "@/views/Solution/components/ProjectDesign/ProjectDesign";
  import Framework from "@/views/Solution/components/Framework/Framework";
  import ProductAndServer from "@/views/Solution/components/ProductAndServer/ProductAndServer";
  import Advantage from "@/views/Solution/components/advantage/advantage";
  import Scene from "@/views/Solution/components/Scene/Scene";
  import ProductServers from "@/views/Solution/components/productServers/productServers";
  const framework = 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E6%9E%B6%E6%9E%84%E5%9B%BE/%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-%E6%95%B0%E5%AD%97%E6%95%99%E8%82%B2-%E6%9E%B6%E6%9E%84%E5%9B%BE.png';
  export default {
    name: "DigitalEducation",
    components: {ProductServers, Scene, Advantage, ProductAndServer, Framework, ProjectDesign, TopInformations},
    props: {},
    data() {
      return {
        framework,
        products: [
          {img: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/AI%E6%95%99%E5%AD%A6icon.png', title: 'AI教学', texts: ['个性化学习解决方案', 'AI教学助手解决方案', 'AI考测系统解决方案']},
          {img: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E6%99%BA%E6%85%A7%E6%A0%A1%E5%8A%A1icon.png', title: '智慧校务', texts: ['教务管理系统解决方案', 'AI校园安防系统解决方案', '智慧课堂软硬件解决方案']},
          {img: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E5%9C%A8%E7%BA%BF%E6%95%99%E8%82%B2icon.png', title: '在线教育', texts: ['在线录、直播解决方案', '在线教育平台解决方案', '家校互动工具解决方案']},
          {img: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E6%95%99%E8%82%B2%E7%AE%A1%E7%90%86icon.png', title: '教育管理', texts: ['资源共享平台解决方案', '学生老师综合评价解决方案', '教育数据大脑管理平台解决方案']},
        ],
        advantages: [
          {
            img1: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%B8%93%E4%B8%9A%E7%9A%84AI%E6%95%99%E8%82%B2%E6%95%99%E5%AD%A6%E4%BD%93%E7%B3%BB.png',
            img2: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%B8%93%E4%B8%9A%E7%9A%84AI%E6%95%99%E8%82%B2%E6%95%99%E5%AD%A6%E4%BD%93%E7%B3%BB2.png',
            title: '专业的AI教育教学体系', text: '16+教育模型、权威教育知识图谱、教育业务图谱洞察教育行业各场景需求，并为其提供智慧教学、智能学习方案'
          },
          {
            img1: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E6%95%99%E5%AD%A6%E5%AE%9E%E8%B7%B5%E5%8A%A9%E5%8A%9B%E4%BA%A7%E6%95%99%E8%9E%8D%E5%90%88.png',
            img2: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E6%95%99%E5%AD%A6%E5%AE%9E%E8%B7%B5%E5%8A%A9%E5%8A%9B%E4%BA%A7%E6%95%99%E8%9E%8D%E5%90%882.png',
            title: '教学实践助力产教融合', text: 'AI驱动学前、基础、高等、职业教育场景打通，并提供各类在线专业实践支撑。实现产教融合，培养数字化人才'},
          {
            img1: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E5%AE%89%E5%85%A8%E7%A8%B3%E5%AE%9A.png',
            img2: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E5%AE%89%E5%85%A8%E7%A8%B3%E5%AE%9A2.png',
            title: '安全稳定，隐私保护', text: '国际领先的数据确权、数据脱敏技术，结合区块链，保证数据不出库仍然可合法调用。最大化实现隐私保护、数据安全'},
          {
            img1: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%BC%81%E4%B8%9A%E8%BF%90%E8%90%A5%E9%99%8D%E6%9C%AC%E5%A2%9E%E6%95%88.png',
            img2: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%BC%81%E4%B8%9A%E8%BF%90%E8%90%A5%E9%99%8D%E6%9C%AC%E5%A2%9E%E6%95%882.png',
            title: '企业运营降本增效', text: '提供IaaS到SaaS层等开放技术服务、专家设计的企业运营方案，助力数字化转型实现可观营收'},
          {
            img1: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%BD%8E%E6%88%90%E6%9C%AC.png',
            img2: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%BD%8E%E6%88%90%E6%9C%AC2.png',
            title: '低成本', text: '方案基于云计算架构、用户无需资产投资建设，按需使用、按需扩展、颠覆传统中投资建设模式'},
        ],
      };
    },
  };
</script>

<style scoped lang="stylus">
  .DigitalEducation {
  
  }
</style>
